module.exports = __webpack_public_path__ + "img/portraits_06_V.71a9af76.webp";